<template>
  <div  v-loading="loading">
    <el-tabs type="border-card"  v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="腾云SaaS系统" name="1">
        <el-tabs  v-model="innerActiveName"  @tab-click="handleTypeClick">
          <el-tab-pane label="菜单权限" name="cd">
            <div class="menu-set-box">
              <p>
                <el-checkbox v-model="expandState" @change="change('expandState',expandState)">展开/折叠</el-checkbox>
                <el-checkbox v-model="allChooseState" @change="change('allChooseState',allChooseState)">全选/全不选</el-checkbox>
                <el-checkbox v-model="linkageState">父子联动</el-checkbox>
              </p>
              <p class="template-menu">
                <el-button v-for="(item,index) in menuTempList" :key="index" type="primary" plain @click="set_templateMenu(item)" size="mini">{{item.text}}</el-button>
              </p>
              <p>
                <el-tree
                    v-if="platform=='1'"
                    :data="menuPermission1"
                    show-checkbox
                    default-expand-all
                    check-on-click-node
                    ref="meunTree1"
                    node-key="menu_id"
                    highlight-current
                    :check-strictly="!linkageState"
                    :props="props_menu">
                </el-tree>
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据权限" name="sj">
            <div class="data-permission-box" v-if="platform=='1'">
              <span>
                数据禁用：
              </span>
              <span style="display: inline-block">
                <el-checkbox-group v-model="pageData_checkList1" @change="show_selected_data('page_text')">
                  <el-checkbox v-for="(item,index) in systemRolePage" :key="index" :label="item.role_page_api_id">{{item.note}}</el-checkbox>
                </el-checkbox-group>
              </span>

            </div>
            <div class="menu-permission-box">
              <el-tabs tab-position="left" v-model="sjActiveName">
                <el-tab-pane label="按照地区分配" name="sj1">
                  <areaAllocation ref="area1" :areaDataInfo="areaDataInfo" :type="1"></areaAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照经销商分配" name="sj2">
                  <distributorAllocation ref="distribute1" :customerDataInfo="customerDataInfo" :type="1"></distributorAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照医院分配" name="sj3">
                  <hospitalAllocation ref="hospital1" :hospitalDataInfo="hospitalDataInfo" :type="1"></hospitalAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照机号分配" name="sj4">
                  <instrumentAllocation ref="instrument1" :instrumentDataInfo="instrumentDataInfo" :type="1"></instrumentAllocation>
                </el-tab-pane>
              </el-tabs>
              <!--              <div>-->
              <!--                <p>-->
              <!--                  数据范围：-->
              <!--                </p>-->
              <!--                <div>-->
              <!--                  <el-select-->
              <!--                      v-model="data_range_value"-->
              <!--                      size="mini"-->
              <!--                      placeholder="请选择"-->
              <!--                      class="leftSelect"-->
              <!--                      filterable-->
              <!--                      clearable-->
              <!--                  >-->
              <!--                    <el-option-->
              <!--                        v-for="item in data_range_list"-->
              <!--                        :key="item.value"-->
              <!--                        :label="item.name"-->
              <!--                        :value="item.value"-->
              <!--                    ></el-option>-->
              <!--                  </el-select>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div>-->
              <!--                <p>数据权限:</p>-->
              <!--                <div class="data-permission-box">-->
              <!--                  <div class="allocation-box allocation-checkbox-box">-->
              <!--                    <span>选择地区</span>-->

              <!--                    <div >-->
              <!--                      <el-checkbox-group v-model="province_checkList" @change="change_province_checkList">-->
              <!--                        <el-checkbox v-for="(item,index) in province_list" :key="index"  :label="item.value">{{item.label}}</el-checkbox>-->
              <!--                      </el-checkbox-group>-->
              <!--                      <p class="city-box" v-show="province_choose_list.length!=0">-->
              <!--                        <el-checkbox v-model="allChoose_city" @change="change_allChoose_city">全选</el-checkbox>-->
              <!--                        <el-checkbox-group v-for="(item,index) in province_choose_list" :key="index" v-model="city_obj[item.value]" @change="$forceUpdate();show_selected_data('city_text');">-->
              <!--                          <el-checkbox v-for="(temp,indeX) in item.city_list" :key="indeX" :label="temp.value">{{temp.label}}</el-checkbox>-->
              <!--                        </el-checkbox-group>-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                  <div class="sales-box">-->
              <!--                    <div class="search-box top">-->
              <!--                      <ul>-->
              <!--                        <li><span>经销商:</span><el-input v-model="sales_list_param.customer_name" size="mini" placeholder="请输入经销商"></el-input></li>-->
              <!--                        <li><span>医院:</span><el-input v-model="sales_list_param.hospital_name" size="mini" placeholder="请输入医院"></el-input></li>-->
              <!--                        <li><span>机号:</span><el-input v-model="sales_list_param.instrument_id" size="mini" placeholder="请输入机号(仅筛选厂内数据)"></el-input></li>-->
              <!--                        <li><el-button type="primary" size="mini" @click="sales_list_param.page=1;get_sales_list()">查找</el-button></li>-->
              <!--                      </ul>-->
              <!--                    </div>-->
              <!--                    <el-divider></el-divider>-->
              <!--                    <div class="sales-list-box">-->
              <!--                      <ul class="table-th">-->
              <!--                        <li>-->
              <!--                          <span>经销商</span>-->
              <!--                          <div>-->
              <!--                            <div>-->
              <!--                              <span>医院</span>-->
              <!--                              <p>机号</p>-->
              <!--                            </div>-->
              <!--                          </div>-->
              <!--                        </li>-->
              <!--                        <li><el-checkbox v-model="allChoose" @change="change_allChoose">全选</el-checkbox></li>-->
              <!--                      </ul>-->
              <!--                      <ul >-->
              <!--                        <li v-for="(item,index) in sales_list" :key="index">-->
              <!--                          <el-divider></el-divider>-->
              <!--                          <span><el-checkbox v-model="item.checked" @change="$forceUpdate();show_selected_data('customer_text')" v-show="item.customer_name">{{item.customer_name}}</el-checkbox></span>-->
              <!--                          <div>-->
              <!--                            <div v-for="(temp,index2) in item.hospital_info2" :key="index2">-->
              <!--                                  <span>-->
              <!--                                    <el-checkbox v-model="temp.checked" @change="$forceUpdate();show_selected_data('hospital_text')">{{ temp.hospital_full_name }}</el-checkbox>-->
              <!--                                  </span>-->
              <!--                              <p>-->
              <!--                                    <span v-for="(e,index3) in temp.instrument_info2" :key="index3">-->
              <!--                                      <el-checkbox v-model="e.checked" @change="$forceUpdate();show_selected_data('instrument_text')">{{ e.label?e.label +'-':e.label }}{{ e.instrument_id }}</el-checkbox>-->
              <!--                                    </span>-->
              <!--                              </p>-->
              <!--                            </div>-->
              <!--                          </div>-->
              <!--                        </li>-->
              <!--                      </ul>-->
              <!--                      <el-button type="primary" size="mini" v-show="loading_more_show" @click="get_sales_list()">加载更多</el-button>-->

              <!--                    </div>-->
              <!--                  </div>-->
              <!--                  <div class="allocation-box">-->
              <!--                    <span>数据禁用：</span>-->
              <!--                    <div class="pageData-box">-->
              <!--                      <el-checkbox-group v-model="pageData_checkList" @change="show_selected_data('page_text')">-->
              <!--                        &lt;!&ndash; <el-checkbox label="单价">单价</el-checkbox>-->
              <!--                        <el-checkbox label="总价">总价</el-checkbox> &ndash;&gt;-->
              <!--                        <el-checkbox v-for="(item,index) in systemRolePage" :key="index" :label="item.role_page_api_id">{{item.note}}</el-checkbox>-->
              <!--                      </el-checkbox-group>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                  <div class="selected-box">-->
              <!--                    <label>已选数据</label>-->
              <!--                    <div style="marginTop:0;">-->
              <!--                      <span>已选地区:</span>-->
              <!--                      <p>-->
              <!--                        {{city_text}}-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <span>已选经销商:</span>-->
              <!--                      <p>-->
              <!--                        {{customer_text}}-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <span>已选医院:</span>-->
              <!--                      <p>-->
              <!--                        {{hospital_text}}-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <span>已选机号:</span>-->
              <!--                      <p>-->
              <!--                        {{instrument_text}}-->
              <!--                      </p>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <span>数据禁用:</span>-->
              <!--                      <p>{{page_text}}</p>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->

            </div>
          </el-tab-pane>

        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="数商系统"  name="2">
        <el-tabs v-model="innerActiveName"  @tab-click="handleTypeClick">
          <el-tab-pane label="菜单权限" name="cd">
            <div class="menu-set-box">
              <p>
                <el-checkbox v-model="expandState" @change="change('expandState',expandState)">展开/折叠</el-checkbox>
                <el-checkbox v-model="allChooseState" @change="change('allChooseState',allChooseState)">全选/全不选</el-checkbox>
                <el-checkbox v-model="linkageState">父子联动</el-checkbox>
              </p>
<!--              <p class="template-menu">-->
<!--                <el-button v-for="(item,index) in menuTempList" :key="index" type="primary" plain @click="set_templateMenu(item)" size="mini">{{item.text}}</el-button>-->
<!--              </p>-->
              <p>
                <el-tree
                    v-if="platform=='2'"
                    :data="menuPermission2"
                    show-checkbox
                    default-expand-all
                    check-on-click-node
                    ref="meunTree2"
                    node-key="menu_id"
                    highlight-current
                    :check-strictly="!linkageState"
                    :props="props_menu">
                </el-tree>
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据权限" name="sj">
<!--            <div class="data-permission-box">-->
<!--              <span>-->
<!--                数据禁用：-->
<!--              </span>-->
<!--              <span style="display: inline-block">-->
<!--                <el-checkbox-group v-model="pageData_checkList2" @change="show_selected_data('page_text')">-->
<!--                  <el-checkbox v-for="(item,index) in systemRolePage" :key="index" :label="item.role_page_api_id">{{item.note}}</el-checkbox>-->
<!--                </el-checkbox-group>-->
<!--              </span>-->

<!--            </div>-->
            <div class="menu-permission-box" v-if="platform=='2'">
              <el-tabs tab-position="left" v-model="sjActiveName">
                <el-tab-pane label="按照地区分配" name="sj5">
                  <areaAllocation ref="area2"  :areaDataInfo="areaDataInfo2" :type="2"></areaAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照经销商分配" name="sj6">
                  <distributorAllocation v-if="platform=='2'" ref="distribute2" :customerDataInfo="customerDataInfo2" :type="2"></distributorAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照医院分配" name="sj7">
                  <hospitalAllocation ref="hospital2" v-if="platform=='2'" :hospitalDataInfo="hospitalDataInfo2" :type="2"></hospitalAllocation>
                </el-tab-pane>
                <el-tab-pane label="按照机号分配" name="sj8">
                  <instrumentAllocation ref="instrument2" v-if="platform=='2'" :instrumentDataInfo="instrumentDataInfo2" :type="2"></instrumentAllocation>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer" >
        <el-button type="primary" @click="put_system_role_permissions" size="small">确 定</el-button>
        <el-button @click="handleCancel" size="small">取 消</el-button>
      </span>
  </div>
</template>
<script>
import {flexColumnWidth} from "@/assets/js/adaption";
import areaAllocation from './areaAllocation.vue'
import hospitalAllocation from "./hospitalAllocation.vue";
import distributorAllocation from "./distributorAllocation.vue";
import instrumentAllocation from "./instrumentAllocation.vue";
import api from "@/api/manage";
import manageMixins from './manageMixins.js'
export default {
  components: {
    areaAllocation,hospitalAllocation,distributorAllocation,instrumentAllocation
  },
  mixins: [manageMixins],
  props: {
    // menuPermission:{
    //   type: Array,
    //   default: () => []
    // }
    permissionsRow:  {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      loading:false,
      areaDataInfo:[],
      areaDataInfo2:[],
      customerDataInfo:[],
      customerDataInfo2:[],
      hospitalDataInfo:[],
      hospitalDataInfo2:[],
      instrumentDataInfo:[],
      instrumentDataInfo2:[],
      platform: '1',
      activeName:  '1',
      innerActiveName:  'cd',
      sjActiveName: 'sj1',
      sales_list: [],
      city_obj: {},
      menuPermission1: [],
      menuPermission2: [],
      treeAllChildNode: [],
      sales_list_param: {
        customer_name: '',
        hospital_name: '',
        instrument_id: '',
        page: 1,
      },
      city_text: '',
      customer_text:'',
      hospital_text:'',
      instrument_text:'',
      page_text:'',
      expandState: true,
      allChooseState: false,
      allChoose: false,
      linkageState: true,
      allChoose_city: false,
      loading_more_show: false,
      systemRolePage: [],
      pageData_checkList1: [],
      pageData_checkList2: [],
      data_range_value: '',
      data_range_list: [],
      province_list: [],
      city_checkList: [],
      province_checkList: [],
      province_choose_list: [],
      props_menu: {
        label: 'menu_title',
        id: 'menu_id',

      },
      menuTempList: [
        {
          id: 1,
          text: '经销商内勤',
          list: [63,64,66,67,69,70,71,72,73,74,75,76,77,78,79,80,83,1,7,8,9,2,10,11,13,14,15]
        },
        {
          id: 2,
          text: '工程师',
          list: [63,64,65,66,67,69,70,71,72,73,74,75,76,77,78,79,80,83,1,7,8,9,2,10,12,13,14,15,4,54]
        },
        {
          id: 3,
          text: '医院用户',
          list: [63,64,69,70,71,72,73,74,75,76,77,78,79,80,83,1,8,9,2,10,14]
        },
      ],
      // menuPermission: [
      //   {
      //     id: 1,
      //     label: '一级 1',
      //     children: [{
      //       id: 4,
      //       label: '二级 1-1',
      //       children: [{
      //         id: 9,
      //         label: '三级 1-1-1'
      //       }, {
      //         id: 10,
      //         label: '三级 1-1-2'
      //       }]
      //     }]
      //   }, {
      //     id: 2,
      //     label: '一级 2',
      //     children: [{
      //       id: 5,
      //       label: '二级 2-1'
      //     }, {
      //       id: 6,
      //       label: '二级 2-2'
      //     }]
      //   }, {
      //     id: 3,
      //     label: '一级 3',
      //     children: [{
      //       id: 7,
      //       label: '二级 3-1'
      //     }, {
      //       id: 8,
      //       label: '二级 3-2'
      //     }]
      //   }
      // ],
    }
  },
  created(){
    this.loading = true
    this.get_system_menu();
  },
  mounted() {
    this.province_list = JSON.parse(localStorage.getItem('province'));
    this.get_system_org();
    this.get_system_role_page_api();
    this.open_permissions_dialog(this.permissionsRow)
  },
  methods: {
    handleTabClick(tab){  // 切换腾云和数商系统
      console.log('tab===',typeof tab.name)
      // this.$confirm('切换系统将清空当前权限，请谨慎操作！', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      //   }).then(() => {
      //
      // }).catch(() => {
      //
      // })
      this.platform = tab.name
      this.innerActiveName = 'cd'
      if(this.platform == '1'){
        this.sjActiveName= 'sj1'
      }else{
        this.sjActiveName= 'sj5'
      }
      // this.areaDataInfo = []
      // this.customerDataInfo = []
      // this.hospitalDataInfo = []
      // this.instrumentDataInfo = []
      console.log('permissionsRow===',this.permissionsRow)
      this.open_permissions_dialog(this.permissionsRow)
      this.get_system_menu();

    },
    handleTypeClick(tab,) { // 切换菜单权限和数据权限
      console.log('ceshi===',tab)
      this.$emit('changePlat',tab.name)
    },
    // 宽度
    flexColumnWidth(width, minWidth) {
      return flexColumnWidth(width, minWidth)
    },
    // 获取系统管理组织机构架构列表
    get_system_org() {
      this.loadingShow('加载中')
      api
          .system_org({ size: 'all' })
          .then((res) => {
            this.orgList = res.data
          })
          .finally((msg) => {
            this.loading.close()
          })
    },
    // 打开获取角色权限弹窗
    open_permissions_dialog(row) {
      // console.log(' 打开获取角色权限弹窗row',row)
      // this.dataList[0].value = row.role_title
      // this.dataList[1].value = row.role_flag
      this.now_row = row
      this.linkageState = false
      this.allChoose = false
      this.loadingShow('请稍后')
      api.system_role_permissions({role_id:row.role_id,platform:this.platform}).then(res => {
        // console.log('open_permissions_dialog-res.data00----',res.data)
        if(this.platform == '1'){
          this.areaDataInfo = res.data.data_permission.province_data
          this.customerDataInfo = res.data.data_permission.customer_data
          this.hospitalDataInfo = res.data.data_permission.hospital_data
          this.instrumentDataInfo = res.data.data_permission.instrument_data
        }else{
          this.areaDataInfo2 = res.data.data_permission.province_data
          this.customerDataInfo2 = res.data.data_permission.customer_data
          this.hospitalDataInfo2 = res.data.data_permission.hospital_data
          this.instrumentDataInfo2 = res.data.data_permission.instrument_data
        }

        let province_checkList = []
        let city_obj = {}
        res.data.data_permission.province_data.forEach(temp => {
          province_checkList.push(temp.province_id);
          city_obj[temp.province_id] = temp.city_list.map(e => e.city_id)
        })
        this.province_checkList = province_checkList
        // this.change_province_checkList(province_checkList)
        //设置省份
        this.province_choose_list = this.province_list.filter(e => province_checkList.includes(e.value))
        // 原来有的不变，原来没有的增加且全选
        for(let key in this.city_obj){
          if(!province_checkList.includes(Number(key))){
            delete this.city_obj[key]
          }
        }
        let city_obj_keys = Object.keys(this.city_obj).map(e => Number(e))
        this.province_choose_list.forEach(e => {
          if(!city_obj_keys.includes(e.value)){
            this.city_obj[e.value] = e.city_list.map(temp => temp.value)
          }
        })
        this.city_obj = city_obj //设置地区
        // 获取应该获取的经销商医院信息
        let city_list = [];
        for(let key in this.city_obj) {
          city_list.push(...this.city_obj[key])
        }
        let customer_list = res.data.data_permission.customer_data
        let hospital_list = res.data.data_permission.hospital_data.map(e => e.hospital_id)

        let instrument_list = res.data.data_permission.instrument_data
        // console.log('res.data.menu_permission',res.data.menu_permission)
        this.instrument_info_list = []
        api.system_instrument_info({city_list,province_list:this.province_checkList}).then(res2=> {
          this.instrument_info_list = res2.data
          this.instrument_info_list.forEach(item => {
            // item.checked = true
            item.checked = customer_list.includes(item.customer_id)
            item.hospital_info.forEach(temp => {
              // temp.checked = true
              temp.checked = hospital_list.includes(temp.hospital_id)
              temp.instrument_info.forEach(e => {
                // e.checked = true
                e.checked = instrument_list.includes(e.instrument_id)
              })
            })
          })
          this.sales_list_param = {
            customer_name: '',
            hospital_name: '',
            instrument_id: '',
            page: 1
          }
          this.get_sales_list()
          this.loading = false
        })
        // 设置数据禁用
        if(this.platform =='1'){
          this.pageData_checkList1 = res.data.data_permission.page_data.map(e => e.role_page_api_id)
        }else{
          this.pageData_checkList2 = res.data.data_permission.page_data.map(e => e.role_page_api_id)
        }
        this.show_selected_data('page_text')
        // 设置地区文字
        let text = '';
        let noCity = [];
        this.province_choose_list.forEach(e=> {
          e.city_list.forEach(temp => {
            if(!this.city_obj[e.value].includes(temp.value)){
              noCity.push(temp.label)
            }
          })
          if(noCity.length!=0){
            text += `${e.label}全部(不含:${noCity.join('、')}) `
          }else{
            text += `${e.label}全部 `
          }
          noCity = [];
        })
        this.city_text = text;

        //设置功能树
        this.dialogVisible_permission = true;
        this.menu_permission = res.data.menu_permission
        // console.log('res.data.menu_permission',res.data.menu_permission)
        // console.log('this.menu_permission',this.menu_permission)
        this.$nextTick(()=> {
          // console.log('res.data.menu_permission===',res.data.menu_permission)
          if(this.platform == 1){
            // this.$refs.meunTree1.setCheckedKeys([])
            this.$refs.meunTree1.setCheckedKeys(res.data.menu_permission)
          }else{
            // this.$refs.meunTree2.setCheckedKeys([])
            this.$refs.meunTree2.setCheckedKeys(res.data.menu_permission)
          }

          // this.linkageState = true
        })

        //
        let screenWidth =  document.body.clientWidth
        if(screenWidth > 1536){
          document.querySelector('.el-tree').style.maxHeight = '600px';
        }else{
          document.querySelector('.el-tree').style.maxHeight = '350px';
        }
        //
      }).finally(msg => {
        this.loading.close();
      })

    },
    // 获取系统角色API接口字段数据字典
    get_system_role_page_api() {
      api.system_role_page_api().then(res => {
        this.systemRolePage = res.data
      })
    },
    // 获取菜单列表
    get_system_menu() {
      api.system_menu({platform:this.platform}).then(res=> {
        if(this.platform ==1){
          this.menuPermission1 = res.data
        }else{
          this.menuPermission2 = res.data
        }
        this.menuPermission = res.data
        this.getTreeAllChildNode(res.data)
      })
    },
    set_templateMenu(item) {
      let list = item.list
      for (let i = 0; i < this.treeAllChildNode.length; i++) {
        if(list.includes(this.treeAllChildNode[i])){
          if(this.platform ==1 ){
            this.$refs['meunTree1'].setChecked(this.treeAllChildNode[i], true, false)
          }else{
            this.$refs['meunTree2'].setChecked(this.treeAllChildNode[i], true, false)
          }
        }else {
          if(this.platform ==1 ){
            this.$refs['meunTree1'].setChecked(this.treeAllChildNode[i], false, false)
          }else{
            this.$refs['meunTree2'].setChecked(this.treeAllChildNode[i], false, false)
          }
        }
      }
    },
    // 获取角色管理仪器信息对应数据字典
    get_system_instrument_info() {
      let city_list = [];
      for(let key in this.city_obj) {
        city_list.push(...this.city_obj[key])
      }
      this.loadingShow('加载中')
      let customer_list = [],hospital_list = [],instrument_list = []
      this.instrument_info_list.forEach(item => {
        if(item.checked){
          customer_list.push(item.customer_id)
        }
        item.hospital_info.forEach(temp => {
          hospital_list.push(temp.hospital_id)
          temp.instrument_info.forEach(e => {
            if(e.checked){
              instrument_list.push(e.instrument_id)
            }
          })
        })
      })
      this.instrument_info_list = [];
      api.system_instrument_info({city_list,province_list:this.province_checkList,}).then(res=> {
        this.instrument_info_list = res.data,
            this.instrument_info_list.forEach(item => {
              // item.checked = this.allChoose;
              item.checked = customer_list.includes(item.customer_id)
              item.hospital_info.forEach(temp => {
                // temp.checked = this.allChoose;
                temp.checked = hospital_list.includes(temp.hospital_id)
                temp.instrument_info.forEach(e => {
                  // e.checked = this.allChoose;
                  e.checked = instrument_list.includes(e.instrument_id)

                })
              })
            })
        this.sales_list_param.page = 1;
        this.get_sales_list()
      }).finally(msg => {
        this.loading.close();
      })
    },
    // 全选地区
    change_allChoose_city(value) {
      this.province_choose_list.forEach(e => {
        this.city_obj[e.value] = value?e.city_list.map(temp => temp.value):[]
      })
      this.show_selected_data('city_text')
    },
    // 全选经销商医院机号
    change_allChoose(value) {
      this.instrument_info_list.forEach(item => {
        item.checked =value
        item.hospital_info.forEach(temp => {
          temp.checked = value
          temp.instrument_info.forEach(e => {
            e.checked = value
          })
        })
      })
      this.show_selected_data('customer_text')
      this.show_selected_data('hospital_text')
      this.show_selected_data('instrument_text')
    },
    // 展示出来的规则显示
    get_sales_list() {
      if(this.sales_list_param.page == 1){
        this.sales_list = [];
      }
      let temp = [];
      this.instrument_info_list.forEach(item => {
        let item_temp = item
        // if(this.sales_list_param.customer_name!=''){ //筛选经销商
        //   if(item.customer_name.includes(this.sales_list_param.customer_name)) { //经销商筛选中了
        //     if(this.sales_list_param.hospital_name!='') { //医院筛选
        //       item_temp.hospital_info2 = item.hospital_info.filter(e => e.hospital_full_name.includes(this.sales_list_param.hospital_name))
        //       if(item_temp.hospital_info2.length>0){temp.push(item_temp)}
        //     }else {
        //       item_temp.hospital_info2 = item.hospital_info
        //       temp.push(item_temp)
        //     }
        //   }
        // }else { //不筛选经销商
        //   if(this.sales_list_param.hospital_name!='') { //医院筛选
        //     item_temp.hospital_info2 = item.hospital_info.filter(e => e.hospital_full_name.includes(this.sales_list_param.hospital_name))
        //     if(item_temp.hospital_info2.length>0){temp.push(item_temp)}
        //   }else {
        //     item_temp.hospital_info2 = item.hospital_info
        //     console.log(item_temp)
        //     temp.push(item_temp)
        //   }
        // }
        if(this.sales_list_param.customer_name!=''&&!item.customer_name.includes(this.sales_list_param.customer_name)){
          return
        }
        if(this.sales_list_param.hospital_name!=''){
          item_temp.hospital_info2 = item.hospital_info.filter(e => e.hospital_full_name.includes(this.sales_list_param.hospital_name))
          if(item_temp.hospital_info2.length==0){
            return
          }
        }else{

          item_temp.hospital_info2 = item.hospital_info
        }
        if(this.sales_list_param.instrument_id!=''){

          item_temp.hospital_info2 = item_temp.hospital_info2.filter(temp => {
            temp.instrument_info2 = temp.instrument_info.filter(e => e.instrument_id === this.sales_list_param.instrument_id)
            return temp.instrument_info2.length!=0
          })
          if(item_temp.hospital_info2.length==0){
            return
          }
        }else {
          item_temp.hospital_info2.filter(temp => {
            temp.instrument_info2 = temp.instrument_info
          })
        }
        temp.push(item_temp)
      })
      this.sales_list.push(...temp.slice(10*(this.sales_list_param.page-1),10*this.sales_list_param.page))
      this.sales_list_param.page++
      this.show_selected_data('customer_text')
      this.show_selected_data('hospital_text')
      this.show_selected_data('instrument_text')

      this.loading_more_show = temp.length>this.sales_list.length
      // this.sales_list.push(...this.instrument_info_list.slice(10*(this.sales_list_param.page-1),10*this.sales_list_param.page))
    },
    // 省份选择切换
    change_province_checkList(value) {
      // 获取城市列表
      this.province_choose_list = this.province_list.filter(e => value.includes(e.value))
      // 原来有的不变，原来没有的增加且全选
      for(let key in this.city_obj){
        if(!value.includes(Number(key))){
          delete this.city_obj[key]
        }
      }
      let city_obj_keys = Object.keys(this.city_obj).map(e => Number(e))
      this.province_choose_list.forEach(e => {
        if(!city_obj_keys.includes(e.value)){
          this.city_obj[e.value] = e.city_list.map(temp => temp.value)
        }
      })
      this.show_selected_data('city_text');
    },
    // 已选数据显示
    show_selected_data(type){
      let text = '';
      switch (type) {
        case 'city_text':
          let noCity = [];
          this.province_choose_list.forEach(e=> {
            e.city_list.forEach(temp => {
              if(!this.city_obj[e.value].includes(temp.value)){
                noCity.push(temp.label)
              }
            })
            if(noCity.length!=0){
              text += `${e.label}全部(不含:${noCity.join('、')}) `
            }else{
              text += `${e.label}全部 `
            }
            noCity = [];
          })
          this.city_text = text;
          this.get_system_instrument_info()
          break;
        case 'customer_text':
          this.instrument_info_list.forEach(item => {
            if(item.checked){
              text += item.customer_name+ '、'
            }
          })
          this.customer_text = text
          break;
        case 'hospital_text':
          let hospital_info_tempList = []
          this.instrument_info_list.forEach(item => {
            item.hospital_info.forEach(temp => {
              if(temp.checked){
                hospital_info_tempList.push(temp.hospital_full_name)
                // text += temp.hospital_full_name+ '、'
              }
            })
          })
          hospital_info_tempList = [...new Set([...hospital_info_tempList])]
          this.hospital_text = hospital_info_tempList.join('、')
          break;
        case 'instrument_text':
          this.instrument_info_list.forEach(item => {
            item.hospital_info.forEach(temp => {
              temp.instrument_info.forEach(e => {
                if(e.checked){
                  text += (e.label?e.label +'-':'') + e.instrument_id+ '、'
                }
              })
            })
          })
          this.instrument_text = text
          break;
        case 'page_text':
          // this.page_text = `订单: ${this.pageData_checkList.join('、')}`
          if(this.platform ==1){
            this.page_text = this.systemRolePage.filter(e => this.pageData_checkList1.indexOf(e.role_page_api_id)!=-1).map(e => e.note).join('、')
          }else{
            this.page_text = this.systemRolePage.filter(e => this.pageData_checkList2.indexOf(e.role_page_api_id)!=-1).map(e => e.note).join('、')
          }

          break;
        default:
          break;
      }
    },
    // 菜单/数据权限提交
    put_system_role_permissions() {
      // 获取包含的菜单列
      let area_permission = []
      let customer_permission = {}
      let hospital_permission = {}
      let instrument_permission = {}
      let menu_permission = []
      let page_permission
      console.log('this.platform',this.platform);
      console.log('this.platform', typeof this.platform);
      console.log('platform == 1', this.platform == 1);
      if(this.platform == 1){
        console.log('腾云提交');
        menu_permission = [...this.$refs.meunTree1.getCheckedKeys(),...this.$refs.meunTree1.getHalfCheckedKeys() ]
        area_permission = this.$refs.area1.areaSelectSubmitList
        customer_permission = this.$refs.distribute1.distrSelectSubmitList
        hospital_permission = this.$refs.hospital1.hosSelectSubmitList
        instrument_permission = this.$refs.instrument1.instrSelectSubmitList
        page_permission = this.pageData_checkList1.map(e => { return {role_page_api_id: e}})
      }else {
        menu_permission = [...this.$refs.meunTree2.getCheckedKeys(),...this.$refs.meunTree2.getHalfCheckedKeys() ]
        area_permission = this.$refs.area2.areaSelectSubmitList
        customer_permission = this.$refs.distribute2.distrSelectSubmitList
        hospital_permission = this.$refs.hospital2.hosSelectSubmitList
        instrument_permission = this.$refs.instrument2.instrSelectSubmitList
        page_permission = this.pageData_checkList2.map(e => { return {role_page_api_id: e}})
      }
      console.log('提交数据instrument_permission---',instrument_permission)
      let param = {
        platform:  this.platform,
        role_id: this.now_row.role_id,
        menu_permission,
        data_permission: {
          area_permission,
          customer_permission,
          hospital_permission,
          instrument_permission,
          page_permission,
        },
      }
      console.log('提交的数据===',param)

      this.loadingShow('保存中')
      api.system_role_permissions_put(param).then(res => {
        if(res.code == 200){
          this.$message.success('设置成功')
          this.loading.close()
          this.$emit('close')
          this.get_system_role()
        }else{
          this.$message.error(res.msg)
        }


      }).finally(msg => {
        this.loading.close()
        this.loading = false
      })

      // // 子菜单选择，父菜单必须选择
      // const getmenu_permission= (list)=> {
      //   let temp = false;
      //   list.forEach(e => {
      //     if(getmenu_permission(e.children)){
      //       temp = true;
      //       if(!menu_permission.includes(e.menu_id)){
      //         menu_permission.push(e.menu_id)
      //       }
      //     }else {
      //       if(menu_permission.includes(e.menu_id)){
      //         temp = true;
      //       }
      //     }
      //   })
      //   return temp
      // }
      // getmenu_permission(this.menuPermission)
      //
      // // 地区列表
      // let city_permission = []
      // for (const key in this.city_obj) {
      //   city_permission.push(...this.city_obj[key])
      // }
      // let customer_permission = []
      // let hospital_permission = []
      // let instrument_permission = []
      // this.instrument_info_list.forEach(item => {
      //   if(item.checked&&item.customer_id){
      //     customer_permission.push(item.customer_id)
      //   }
      //   item.hospital_info.forEach(temp => {
      //     if(temp.checked){
      //       hospital_permission.push(temp.hospital_id)
      //     }
      //     temp.instrument_info.forEach(e => {
      //       if(e.checked){
      //         instrument_permission.push(e.instrument_id)
      //       }
      //     })
      //   })
      // })
      // customer_permission = customer_permission.filter(e => e!= null)
      // // 页面隐藏字段
      // let page_permission = this.pageData_checkList.map(e => { return {role_page_api_id: e}})
      // let param = {
      //   role_id: this.now_row.role_id,
      //   menu_permission,
      //   data_permission: {
      //     city_permission,
      //     customer_permission,
      //     hospital_permission,
      //     instrument_permission,
      //     page_permission,
      //   }
      // }
      //

    },
    handleCancel(){  // 取消
      this.$emit('close')
      // tab切换回到最初的初始化
      this.activeName = '1'
      this.innerActiveName =  'cd'
      this.sjActiveName= 'sj1'
      // 树节点重置为空
      this.$refs.meunTree1.setCheckedKeys([])
      this.$refs.meunTree2.setCheckedKeys([])
    },
    // 切换多选框筛选
    change(type,state) {
      if(this.platform == '1'){
      switch (type) {
        case 'expandState':
          for (var i = 0; i < this.$refs.meunTree1.store._getAllNodes().length; i++) {
            this.$refs.meunTree1.store._getAllNodes()[i].expanded = state

          }
          break;
        case 'allChooseState':
          if (state) {
            // 	设置目前勾选的节点，使用此方法必须设置 node-key 属性
            this.$refs.meunTree1.setCheckedNodes(this.menuPermission);
            for (let i = 0; i < this.treeAllChildNode.length; i++) {
              this.$refs['meunTree1'].setChecked(this.treeAllChildNode[i], true, false)
            }
          } else {
            // 全部不选中
            this.$refs.meunTree1.setCheckedNodes([])
          }
          break;
        default:
          break;
      }
      }else{
        switch (type) {
          case 'expandState':
            for (var i = 0; i < this.$refs.meunTree2.store._getAllNodes().length; i++) {
              this.$refs.meunTree2.store._getAllNodes()[i].expanded = state

            }
            break;
          case 'allChooseState':
            if (state) {
              // 	设置目前勾选的节点，使用此方法必须设置 node-key 属性
              this.$refs.meunTree2.setCheckedNodes(this.menuPermission);
              for (let i = 0; i < this.treeAllChildNode.length; i++) {
                this.$refs['meunTree2'].setChecked(this.treeAllChildNode[i], true, false)
              }
            } else {
              // 全部不选中
              this.$refs.meunTree2.setCheckedNodes([])
            }
            break;
          default:
            break;
        }
      }
    },
    // 递归获取树所有可选择的子节点
    getTreeAllChildNode(treeData) {
      // 树长度为0 结束操作
      if (treeData.length === 0) {
        return
      }
      // 遍历树的数据
      for (let i = 0; i < treeData.length; i++) {
        // 当前遍历的数据是否还有子节点
        let children = treeData[i].children
        if (children && children.length > 0) {
          // 有，则递归
          this.treeAllChildNode.push(treeData[i].menu_id)
          this.getTreeAllChildNode(children)
        } else {
          // 没有，则判断当前节点是否是可选择状态
          // 将子节点id 追加给 treeAllChildNode （子节点数组也可声明为对象，将节点信息存储）
          this.treeAllChildNode.push(treeData[i].menu_id)
        }
      }
    },

  }
}
</script>

<style scoped lang="scss">
.data-permission-box{
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 20px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
}
.menu-permission-box{
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 20px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
}
.el-dialog__body{
  padding: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
::v-deep .el-tabs__item.is-active,::v-deep .el-tabs__item:hover,::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #0052D9;
}
::v-deep .el-tabs__active-bar{
  background-color: #0052D9;
}
::v-deep .el-cascader .el-input .el-input__inner:focus,::v-deep  .el-cascader .el-input.is-focus .el-input__inner {
  border-color: #0052D9;
}
::v-deep .el-tree.el-tree--highlight-current{
  max-height: 380px;
  overflow: auto;
}

</style>